import Component from './component';

export interface Props {
    text: string;
}

Component.defaultProps = {};

export default Component;